var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "区服：",
      "label-width": "100px"
    }
  }, [[_c("el-input", {
    staticStyle: {
      width: "180px",
      height: "38px"
    },
    model: {
      value: _vm.serverId,
      callback: function callback($$v) {
        _vm.serverId = $$v;
      },
      expression: "serverId"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "聊天监控频道：",
      "label-width": "180px"
    }
  }, [[_c("el-input", {
    staticStyle: {
      width: "180px",
      height: "38px"
    },
    model: {
      value: _vm.channel_value,
      callback: function callback($$v) {
        _vm.channel_value = $$v;
      },
      expression: "channel_value"
    }
  })]], 2), _c("el-form-item", {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c("el-button", {
          attrs: {
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.queryEvent();
            }
          }
        }, [_vm._v("查询")])];
      },
      proxy: true
    }])
  })], 1), _vm._m(0), _c("div", [[_c("el-table", {
    ref: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      height: "400",
      border: "",
      "header-cell-style": {
        background: "#eef1f6",
        color: "#606266"
      }
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "index",
      width: "80",
      label: "顺序"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      height: "150",
      label: "区服",
      prop: "serverId"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      height: "150",
      label: "玩家名称",
      prop: "roleName"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      height: "150",
      label: "角色ID",
      prop: "roleId"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      height: "150",
      label: "玩家禁言"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-tag", {
          attrs: {
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.goChatRouterMsg(scope.row.roleId);
            }
          }
        }, [_vm._v("go玩家禁言")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      height: "150",
      label: "玩家封禁"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-tag", {
          attrs: {
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.goUserRouterMsg(scope.row.roleId);
            }
          }
        }, [_vm._v("go玩家封禁")])];
      }
    }])
  })], 1)]], 2)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      height: "22px",
      color: "red"
    }
  }, [_vm._v(" 备注： "), _c("span", {
    staticStyle: {
      color: "#67C23A",
      "font-weight": "bold"
    }
  }, [_vm._v("未对接")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };